import { InferType, object, string } from 'yup';

import { UserSettings } from '../types';

export const languagesScheme = object({
  name: string<UserSettings.Languages>().required(),
  value: string().nullable(),
});

export type Languages = InferType<typeof languagesScheme>;
